import React, { useMemo } from "react";
import { MessageWithId } from "../../store/conversationMessagesSlice";
import { getToolUIComponents } from "./toolLoadingRegistry";
import { DefaultToolLoading } from "./DefaultToolLoading";
import { DefaultToolExecuting } from "./DefaultToolExecuting";

export type ToolState = "loading" | "executing" | "completed";

interface UnifiedToolComponentProps {
  toolCallMessage: Extract<MessageWithId, { type: "tool_call" }>;
  toolResultMessage?: Extract<MessageWithId, { type: "tool_result" }>;
  state: ToolState;
}

export const UnifiedToolComponent: React.FC<UnifiedToolComponentProps> = ({
  toolCallMessage,
  toolResultMessage,
  state,
}) => {
  const { toolName, args } = toolCallMessage.content;
  
  const toolUIComponents = useMemo(() => {
    return getToolUIComponents(toolName);
  }, [toolName]);

  switch (state) {
    case "loading": {
      const LoadingComponent = toolUIComponents.LoadingComponent || DefaultToolLoading;
      return <LoadingComponent toolName={toolName} args={args} />;
    }
    
    case "executing": {
      const ExecutingComponent = toolUIComponents.ExecutingComponent || DefaultToolExecuting;
      return <ExecutingComponent toolName={toolName} args={args} />;
    }
    
    case "completed": {
      if (!toolResultMessage) {
        // Fallback to executing state if no result yet
        const ExecutingComponent = toolUIComponents.ExecutingComponent || DefaultToolExecuting;
        return <ExecutingComponent toolName={toolName} args={args} />;
      }
      
      const ResultComponent = toolUIComponents.ResultComponent;
      return <ResultComponent result={toolResultMessage.content.result} args={args} />;
    }
    
    default:
      return null;
  }
};